(function() {
  if (customElements.get('hero-video-slider')) {
    return;
  }

  class HeroVideoSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-hero-video-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hero-video-dot]'));
      this.ctaButtons = Array.prototype.slice.call(this.querySelectorAll('.hero__link .btn'));
      this.videos = Array.prototype.slice.call(this.querySelectorAll('video'));
      this.pauseButton = this.querySelector('[data-hero-video-pause]');
      this.previousButton = this.querySelector('[data-hero-video-prev]');
      this.nextButton = this.querySelector('[data-hero-video-next]');
      this.progressCircle = this.querySelector('[data-hero-video-progress]');
      this.currentIndex = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.interactionPaused = false;
      this.ctaHovered = false;
      this.ctaFocused = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handleDotClick = this.handleDotClick.bind(this);
      this.handleSectionClick = this.handleSectionClick.bind(this);
      this.handlePauseClick = this.handlePauseClick.bind(this);
      this.handlePreviousClick = this.handlePreviousClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handleCtaMouseEnter = this.handleCtaMouseEnter.bind(this);
      this.handleCtaMouseLeave = this.handleCtaMouseLeave.bind(this);
      this.handleCtaFocus = this.handleCtaFocus.bind(this);
      this.handleCtaBlur = this.handleCtaBlur.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handlePointerCancel = this.handlePointerCancel.bind(this);
      this.handleVideoLoadedMetadata = this.handleVideoLoadedMetadata.bind(this);
      this.handleVideoTimeUpdate = this.handleVideoTimeUpdate.bind(this);
      this.handleVideoEnded = this.handleVideoEnded.bind(this);

      this.addEventListener('click', this.handleDotClick);
      this.addEventListener('click', this.handleSectionClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerCancel);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('resize', this.handleResize);

      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', this.handlePauseClick);
      }

      if (this.previousButton) {
        this.previousButton.addEventListener('click', this.handlePreviousClick);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.handleNextClick);
      }

      this.ctaButtons.forEach(function(button) {
        button.addEventListener('mouseenter', this.handleCtaMouseEnter);
        button.addEventListener('mouseleave', this.handleCtaMouseLeave);
        button.addEventListener('focus', this.handleCtaFocus);
        button.addEventListener('blur', this.handleCtaBlur);
      }.bind(this));

      this.videos.forEach(function(video) {
        video.loop = this.slides.length === 1;
        video.addEventListener('loadedmetadata', this.handleVideoLoadedMetadata);
        video.addEventListener('timeupdate', this.handleVideoTimeUpdate);
        video.addEventListener('ended', this.handleVideoEnded);
      }.bind(this));

      this.setSlideState(0, false);
      this.classList.add('loaded');
      this.syncVideoPlayback();
      this.resetProgress();
      this.startTimer();
    }

    disconnectedCallback() {
      if (!this.initialized) {
        return;
      }

      this.stopTimer();
      window.clearTimeout(this.transitionTimer);
      window.clearTimeout(this.resizeTimer);
      window.clearTimeout(this.suppressClickTimer);
      this.removeEventListener('click', this.handleDotClick);
      this.removeEventListener('click', this.handleSectionClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerCancel);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('resize', this.handleResize);

      if (this.pauseButton) {
        this.pauseButton.removeEventListener('click', this.handlePauseClick);
      }

      if (this.previousButton) {
        this.previousButton.removeEventListener('click', this.handlePreviousClick);
      }

      if (this.nextButton) {
        this.nextButton.removeEventListener('click', this.handleNextClick);
      }

      this.ctaButtons.forEach(function(button) {
        button.removeEventListener('mouseenter', this.handleCtaMouseEnter);
        button.removeEventListener('mouseleave', this.handleCtaMouseLeave);
        button.removeEventListener('focus', this.handleCtaFocus);
        button.removeEventListener('blur', this.handleCtaBlur);
      }.bind(this));

      this.videos.forEach(function(video) {
        video.removeEventListener('loadedmetadata', this.handleVideoLoadedMetadata);
        video.removeEventListener('timeupdate', this.handleVideoTimeUpdate);
        video.removeEventListener('ended', this.handleVideoEnded);
      }.bind(this));

      this.initialized = false;
    }

    handleDotClick(event) {
      var dot = event.target.closest('[data-hero-video-dot]');

      if (!dot || !this.contains(dot)) {
        return;
      }

      var nextIndex = parseInt(dot.dataset.index, 10);
      this.showSlide(nextIndex, nextIndex < this.currentIndex ? -1 : 1);
    }

    handleSectionClick(event) {
      if (this.suppressSectionClick) {
        this.suppressSectionClick = false;
        event.preventDefault();
        return;
      }

      if (event.defaultPrevented || event.target.closest('a, button, input, select, textarea, label')) {
        return;
      }

      var slide = event.target.closest('[data-hero-video-slide]') || this.slides[this.currentIndex];

      if (!slide || !slide.classList.contains('is-active') || !slide.dataset.primaryLink) {
        return;
      }

      this.openPrimaryLink(slide);
    }

    openPrimaryLink(slide) {
      if (slide && slide.dataset.primaryLink) {
        window.location.assign(slide.dataset.primaryLink);
      }
    }

    handlePauseClick() {
      this.userPaused = !this.userPaused;
      this.pauseButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
      this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play hero slideshow' : 'Pause hero slideshow');

      if (this.userPaused) {
        this.stopTimer();
        this.syncVideoPlayback();
      } else {
        this.syncVideoPlayback();
        this.startTimer();
      }
    }

    handlePreviousClick() {
      this.showSlide(this.currentIndex - 1, -1);
    }

    handleNextClick() {
      this.showSlide(this.currentIndex + 1, 1);
    }

    handleCtaMouseEnter() {
      this.ctaHovered = true;
      this.stopTimer();
    }

    handleCtaMouseLeave() {
      this.ctaHovered = false;
      this.startTimer();
    }

    handleCtaFocus() {
      this.ctaFocused = true;
      this.stopTimer();
    }

    handleCtaBlur() {
      this.ctaFocused = false;
      this.startTimer();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopTimer();
        this.syncVideoPlayback();
      } else {
        this.syncVideoPlayback();
        this.startTimer();
      }
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(function() {
        this.syncVideoPlayback();
        this.startTimer();
      }.bind(this), 150);
    }

    handleVideoLoadedMetadata(event) {
      if (event.target !== this.getActiveVideo()) {
        return;
      }

      this.updateVideoProgress(event.target);
      this.startTimer();
    }

    handleVideoTimeUpdate(event) {
      if (event.target === this.getActiveVideo()) {
        this.updateVideoProgress(event.target);
      }
    }

    handleVideoEnded(event) {
      if (event.target !== this.getActiveVideo()) {
        return;
      }

      this.updateVideoProgress(event.target);

      if (this.canAutoplay()) {
        this.showSlide(this.currentIndex + 1, 1);
      }
    }

    handleBlockSelect(event) {
      var slide = event.target.closest('[data-hero-video-slide]');

      if (!slide || !this.contains(slide)) {
        return;
      }

      this.interactionPaused = true;
      this.stopTimer();
      this.showSlide(parseInt(slide.dataset.index, 10));
    }

    handleBlockDeselect() {
      this.interactionPaused = false;
      this.startTimer();
    }

    handlePointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      if (event.target.closest('a, button, input, select, textarea, label')) {
        return;
      }

      this.pointerId = event.pointerId;
      this.pointerDownSlide = event.target.closest('[data-hero-video-slide]') || this.slides[this.currentIndex];
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;
      this.gesturePaused = true;
      this.stopTimer();

    }

    handlePointerMove(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;

      var distanceX = this.pointerLastX - this.pointerStartX;
      var distanceY = this.pointerLastY - this.pointerStartY;

      if (this.slides.length > 1 && Math.abs(distanceX) > 10 && Math.abs(distanceX) > Math.abs(distanceY)) {
        if (this.setPointerCapture && (!this.hasPointerCapture || !this.hasPointerCapture(event.pointerId))) {
          this.setPointerCapture(event.pointerId);
        }

        this.classList.add('is-swiping');
        event.preventDefault();
      }
    }

    handlePointerUp(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;
      this.finishSwipe(true);
    }

    handlePointerCancel(event) {
      if (event.pointerId === this.pointerId) {
        this.finishSwipe(false);
      }
    }

    finishSwipe(shouldNavigate) {
      var distanceX = this.pointerLastX - this.pointerStartX;
      var distanceY = this.pointerLastY - this.pointerStartY;
      var threshold = Math.min(80, Math.max(45, this.clientWidth * 0.05));
      var isHorizontalSwipe = Math.abs(distanceX) >= threshold && Math.abs(distanceX) > Math.abs(distanceY) * 1.2;
      var movedEnoughToSuppressClick = Math.abs(distanceX) > 10 || Math.abs(distanceY) > 10;
      var clickedSlide = this.pointerDownSlide;

      if (movedEnoughToSuppressClick) {
        this.suppressSectionClick = true;
        window.clearTimeout(this.suppressClickTimer);
        this.suppressClickTimer = window.setTimeout(function() {
          this.suppressSectionClick = false;
        }.bind(this), 400);
      }

      if (this.releasePointerCapture && this.hasPointerCapture && this.hasPointerCapture(this.pointerId)) {
        this.releasePointerCapture(this.pointerId);
      }

      this.classList.remove('is-swiping');
      this.pointerId = null;
      this.pointerDownSlide = null;
      this.gesturePaused = false;

      if (shouldNavigate && isHorizontalSwipe && this.slides.length > 1) {
        var direction = distanceX < 0 ? 1 : -1;
        this.showSlide(this.currentIndex + direction, direction);
      } else if (shouldNavigate && !movedEnoughToSuppressClick && clickedSlide && clickedSlide.classList.contains('is-active') && clickedSlide.dataset.primaryLink) {
        this.suppressSectionClick = true;
        window.clearTimeout(this.suppressClickTimer);
        this.suppressClickTimer = window.setTimeout(function() {
          this.suppressSectionClick = false;
        }.bind(this), 400);
        this.openPrimaryLink(clickedSlide);
      } else {
        this.startTimer();
      }
    }

    showSlide(nextIndex, direction) {
      if (this.slides.length < 2 || isNaN(nextIndex)) {
        return;
      }

      nextIndex = (nextIndex + this.slides.length) % this.slides.length;
      direction = direction === -1 ? -1 : 1;

      if (nextIndex === this.currentIndex) {
        this.startTimer();
        return;
      }

      var currentSlide = this.slides[this.currentIndex];
      var nextSlide = this.slides[nextIndex];

      window.clearTimeout(this.transitionTimer);
      this.slides.forEach(function(slide) {
        if (slide !== currentSlide) {
          slide.classList.remove('is-exiting');
          slide.classList.remove('is-exiting-right');
          slide.classList.remove('is-preparing-left');
          slide.classList.remove('is-preparing-right');
        }
      });

      var preparingClass = direction === -1 ? 'is-preparing-left' : 'is-preparing-right';
      var exitingClass = direction === -1 ? 'is-exiting-right' : 'is-exiting';

      currentSlide.classList.remove('is-exiting');
      currentSlide.classList.remove('is-exiting-right');
      nextSlide.classList.remove('is-exiting');
      nextSlide.classList.remove('is-exiting-right');
      nextSlide.classList.add(preparingClass);
      nextSlide.offsetWidth;

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add(exitingClass);
      currentSlide.setAttribute('aria-hidden', 'true');
      currentSlide.setAttribute('inert', '');

      nextSlide.classList.remove(preparingClass);
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');
      nextSlide.removeAttribute('inert');

      nextSlide.querySelectorAll('video').forEach(function(video) {
        try {
          video.currentTime = 0;
        } catch (error) {
          // The video will still begin normally if metadata is not ready yet.
        }
      });

      this.currentIndex = nextIndex;
      this.updateDots();
      this.resetProgress();
      this.syncVideoPlayback();

      this.transitionTimer = window.setTimeout(function() {
        currentSlide.classList.remove('is-exiting');
        currentSlide.classList.remove('is-exiting-right');
      }, this.reduceMotion ? 0 : 720);

      this.startTimer();
    }

    setSlideState(activeIndex, animate) {
      this.currentIndex = activeIndex;

      this.slides.forEach(function(slide, index) {
        var isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.classList.remove('is-exiting');
        slide.classList.remove('is-exiting-right');
        slide.classList.remove('is-preparing-left');
        slide.classList.remove('is-preparing-right');
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      this.updateDots();
    }

    updateDots() {
      this.dots.forEach(function(dot, index) {
        dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
      }.bind(this));
    }

    syncVideoPlayback() {
      var activeSlide = this.slides[this.currentIndex];

      this.slides.forEach(function(slide) {
        var videos = slide.querySelectorAll('video');

        videos.forEach(function(video) {
          var shouldPlay = slide === activeSlide && video.getClientRects().length > 0 && !document.hidden && !this.userPaused;

          if (shouldPlay) {
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function() {});
            }
          } else {
            video.pause();
          }
        }.bind(this));
      }.bind(this));
    }

    startTimer() {
      this.stopTimer();

      if (!this.canAutoplay()) {
        return;
      }

      var activeVideo = this.getActiveVideo();

      if (activeVideo) {
        this.updateVideoProgress(activeVideo);

        if (activeVideo.ended) {
          this.showSlide(this.currentIndex + 1, 1);
        }

        return;
      }

      this.startProgress(this.speed);

      this.timer = window.setTimeout(function() {
        this.showSlide(this.currentIndex + 1);
      }.bind(this), this.speed);
    }

    stopTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
      this.stopProgress();
    }

    canAutoplay() {
      return this.autoplayEnabled && !this.reduceMotion && !this.userPaused && !this.interactionPaused && !this.ctaHovered && !this.ctaFocused && !this.gesturePaused && !document.hidden && this.slides.length > 1;
    }

    getActiveVideo() {
      var activeSlide = this.slides[this.currentIndex];

      if (!activeSlide) {
        return null;
      }

      var videos = activeSlide.querySelectorAll('video');

      for (var index = 0; index < videos.length; index += 1) {
        if (videos[index].getClientRects().length > 0) {
          return videos[index];
        }
      }

      return null;
    }

    resetProgress() {
      if (!this.progressCircle) {
        return;
      }

      this.progressCircle.style.transition = 'none';
      this.progressCircle.style.strokeDashoffset = '100';
      this.progressCircle.getBoundingClientRect();
    }

    startProgress(duration) {
      if (!this.progressCircle) {
        return;
      }

      this.resetProgress();
      this.progressCircle.style.transition = 'stroke-dashoffset ' + duration + 'ms linear';
      this.progressCircle.style.strokeDashoffset = '0';
    }

    updateVideoProgress(video) {
      if (!this.progressCircle || !isFinite(video.duration) || video.duration <= 0) {
        return;
      }

      var progress = Math.min(1, Math.max(0, video.currentTime / video.duration));
      this.progressCircle.style.transition = video.paused ? 'none' : 'stroke-dashoffset 250ms linear';
      this.progressCircle.style.strokeDashoffset = String(100 - (progress * 100));
    }

    stopProgress() {
      if (!this.progressCircle) {
        return;
      }

      var currentOffset = window.getComputedStyle(this.progressCircle).strokeDashoffset;
      this.progressCircle.style.transition = 'none';
      this.progressCircle.style.strokeDashoffset = currentOffset;
    }
  }

  customElements.define('hero-video-slider', HeroVideoSlider);
})();
